/**
 * Exposes the host's React instances on window so that remote apps
 * loaded via Module Federation use the SAME React instance.
 *
 * This runs at module-evaluation time (before any component renders).
 * Remote apps read from window.__FOCUS_SHARED__ instead of bundling
 * their own React — which prevents the "hooks called with different
 * React instance" error.
 */
import * as React from 'react'
import * as ReactDOM from 'react-dom'
import * as jsxRuntime from 'react/jsx-runtime'

if (typeof window !== 'undefined') {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const w = window as any
  if (!w.__FOCUS_SHARED__) {
    w.__FOCUS_SHARED__ = {
      react: React,
      'react-dom': ReactDOM,
      'react/jsx-runtime': jsxRuntime,
    }
  }
}
